import { useTranslation } from 'react-i18next';
import { useThemedValueSwitch } from '@tq/ui-components';
import { ListRowProps } from 'tools';
import { Consultation, ApplicationResponse } from 'types';
import { DataItemConfiguration } from 'types/DataItemConfiguration';
import { getContactDetails } from './getContactDetails';
import { useImportantDates } from './useImportantDates';
import { useApplicationDetailItems } from './useApplicationDetailItems';

type ApplicationDetails = {
  applicationDetails: ListRowProps[];
  importantDates: ListRowProps[];
  contactDetails: ListRowProps[];
};

export const useApplicationDetails = (
  application?: ApplicationResponse,
  consultation?: Consultation,
  dataItemsToDisplay?: DataItemConfiguration[]
): ApplicationDetails => {
  const { t } = useTranslation('case_details_tab');
  const { isTQ } = useThemedValueSwitch();
  let applicationDetails = useApplicationDetailItems(t, isTQ, application, consultation);
  const contactDetails = getContactDetails(t, application, consultation);
  const importantDates = useImportantDates(t, application);

  let finalApplicationDetails: ListRowProps[] = [...applicationDetails];

  if (dataItemsToDisplay !== undefined) {
    const itemsNotToDisplay = dataItemsToDisplay
      .filter((item) => !item.shouldDisplayDataItem)
      .map((item) => item.dataItemName.toLowerCase());

    finalApplicationDetails = applicationDetails.filter(
      (item) => !itemsNotToDisplay.includes(item.label.toLocaleLowerCase())
    );
    applicationDetails = finalApplicationDetails;
  }

  return { applicationDetails, importantDates, contactDetails };
};
